<template>
  <div class="verifiedSignature" @click="getVerifiedSignature">
    <b-image class="verifiedSignatureImage"
        :src="signature.imageUrl"
        responsive
    ></b-image>

    <hr id="hrDivider">
    <div class="verificationDetailsArea">
      {{signature.verifiedSignatureData.otp_verified_time}} | {{signature.verifiedSignatureData.hash_value}}
    </div>
    <p class="otpLabel">OTP verified</p>
  </div>
</template>

<script>

// import Signature from "@/classes/Signature";
export default {

  name : 'verified-signature',

  props:{
    signature:{ // to store signature verified signature (Signature class type object)
      type: Object,
      default: null,
    },
  },

  data(){
    return {

    }
  },

  methods:{

    /**
     * This method is used to custom event that returns selected signature as image
     */
    getVerifiedSignature(){
      console.log("Verified signature clicked")
      const comp = this
        try {
          if (comp.signature.imageUrl !== '' ){

            let returnSignature= comp.signature
            // returnSignature.isSignatureVerified = true // commented since this modal receives only verified signatures

            // test download to see the  image -------------------------
            // let a = document.createElement('a');
            // a.href = comp.signature.imageUrl
            // a.download = 'verified_signature_image.jpg';
            // a.click();
            //
            //
            // setTimeout(() => {
            //   a.remove()
            //   window.URL.revokeObjectURL(comp.signature.imageUrl);
            // }, 100);

            // end of test download ------------------------------------

            comp.$emit('on-verified-signature-selected',returnSignature)
          }
        }
        catch (e) {
          console.log("An exception occurred in getVerifiedSignature() : "+e.message())
        }
    },
  },

}

</script>

<style scoped>
.verifiedSignature:hover{
  border: 2px solid #93FF73;
  cursor: pointer;
}

.verifiedSignature{
  background-color: white;
  border: 1px solid #93FF73;
  border-radius: 12px;
  padding: 5px;
  min-width: 150px;
  min-height: 100px;
}

.verifiedSignatureImage{
  margin-bottom: 0;
  padding: 0;
}

#hrDivider{
  height: 0.5px;
  background-color: black;
  margin-bottom: 5px;
  margin-top: 5px;
}


.verificationDetailsArea, .otpLabel {
  font-size: 6pt;
  text-align: justify;
}

.otpLabel{
  text-align: justify;
}

</style>